// Convert a stream/watch URL into an embeddable iframe src.
export const toEmbedUrl = (url, platform) => {
  if (!url) return null;
  try {
    if (platform === 'youtube' || /youtu\.?be/.test(url)) {
      const m = url.match(/(?:v=|youtu\.be\/|\/live\/|\/embed\/|\/shorts\/)([\w-]{6,})/);
      if (m) return `https://www.youtube.com/embed/${m[1]}`;
    }
    if (platform === 'vimeo' || /vimeo\.com/.test(url)) {
      const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return `https://player.vimeo.com/video/${m[1]}`;
    }
    if (platform === 'facebook' || /facebook\.com|fb\.watch/.test(url)) {
      return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false&width=800`;
    }
  } catch (e) { /* noop */ }
  return url; // "other" / already an embed URL
};

// Zoom / Meet links are join links, not embeddable.
export const isJoinLink = (platform, url) => platform === 'zoom' || /zoom\.us|meet\.google\.com/.test(url || '');

// Convert a YouTube video OR playlist URL into an embeddable src.
export const toPlaylistEmbed = (url) => {
  if (!url) return null;
  try {
    const list = url.match(/[?&]list=([\w-]+)/);
    if (list) return `https://www.youtube.com/embed/videoseries?list=${list[1]}`;
    const vid = url.match(/(?:v=|youtu\.be\/|\/embed\/|\/shorts\/|\/live\/)([\w-]{6,})/);
    if (vid) return `https://www.youtube.com/embed/${vid[1]}`;
  } catch (e) { /* noop */ }
  return url;
};

// Osho Library: return an embeddable player src for YouTube (video/playlist),
// Vimeo and SoundCloud; otherwise null (caller shows a clickable card).
export const toResourceEmbed = (url) => {
  if (!url) return null;
  try {
    if (/youtube\.com|youtu\.be/.test(url)) return toPlaylistEmbed(url);
    if (/vimeo\.com/.test(url)) {
      const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
      if (m) return `https://player.vimeo.com/video/${m[1]}`;
    }
    if (/soundcloud\.com/.test(url)) {
      return `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}&color=%234A1721&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&visual=false`;
    }
  } catch (e) { /* noop */ }
  return null;
};

export const isSoundcloud = (url) => /soundcloud\.com/.test(url || '');

// Direct media file links (played with native <audio>/<video>, not an iframe).
export const isDirectAudio = (url) => /\.(mp3|wav|ogg|oga|m4a|aac|flac)(\?.*)?$/i.test(url || '');
export const isDirectVideo = (url) => /\.(mp4|webm|mov|m4v|ogv)(\?.*)?$/i.test(url || '');


export const googleCalendarUrl = (s) => {
  if (!s.scheduled_at) return null;
  const start = new Date(s.scheduled_at);
  const end = new Date(start.getTime() + (s.duration_minutes || 60) * 60000);
  const fmt = (d) => d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  const p = new URLSearchParams({
    action: 'TEMPLATE',
    text: s.title,
    dates: `${fmt(start)}/${fmt(end)}`,
    details: `${s.description || ''}${s.stream_url ? '\n\nWatch: ' + s.stream_url : ''}`,
  });
  return `https://calendar.google.com/calendar/render?${p.toString()}`;
};
